<template>
    <router-view></router-view>
</template>

<style src="./AxxessHome.scss"></style>
<script src="./AxxessHome.ts"></script>
